<template>
  <family-page-wrapper>
    <request-home-services />
  </family-page-wrapper>
</template>

<script setup lang="ts">
import { defineAsyncComponent } from 'vue';

const RequestHomeServices = defineAsyncComponent(() => import('../Operator/HomeServices/RequestHomeServices.vue') as any);
</script>
